export type PillColor = 'blue' | 'green' | 'red' | 'orange' | 'purple' | 'neutral'

interface PillProps {
  color?: PillColor
  children: React.ReactNode
}

export const getButtonClasses = ({ color }: { color: PillColor }) => {
  const base = 'flex w-fit rounded-full px-3 py-1 text-xs'

  const map: Record<PillColor, string> = {
    purple: 'bg-old-purple-light text-old-purple-dark',
    orange: 'bg-old-orange-light text-old-orange-dark',
    blue: 'bg-old-blue-light  text-old-blue-dark',
    green: 'bg-old-success-light text-old-success-default',
    red: 'bg-red-100 text-red-600',
    neutral: 'bg-white text-old-secondary',
  }

  return `${base} ${map[color]}`
}

const Pill = ({ color = 'neutral', children }: PillProps) => {
  const classes = `${getButtonClasses({ color })}`

  return <div className={`${classes} text-nowrap`}>{children}</div>
}

export default Pill
